import React from 'react'

import { useTheme } from '../../data/theme/'
import { Theme } from '../../data/theme/'

interface ThemeContextProviderProps {
  children?: React.ReactNode
}

export type ThemeContextType = {
  theme?: Theme
  isLoaded?: boolean
}

const initValue: ThemeContextType = {
  theme: undefined,
  isLoaded: false,
}

export const ThemeContext = React.createContext<ThemeContextType>(initValue)

const ThemeContextProvider: React.FC<ThemeContextProviderProps> = ({
  children,
}) => {
  const { data: theme, isLoading } = useTheme()

  return (
    <ThemeContext.Provider
      value={{
        theme,
        isLoaded: !isLoading,
      }}
    >
      <>{children}</>
    </ThemeContext.Provider>
  )
}

export default ThemeContextProvider
